import { render } from "./OfficialPreview.vue?vue&type=template&id=5389b91c"
import script from "./OfficialPreview.vue?vue&type=script&lang=ts"
export * from "./OfficialPreview.vue?vue&type=script&lang=ts"
script.render = render

export default script